import ApiClientAsync from "../../api/ApiClientAsync";
import { getDefaultMarketId } from "../getDefaultMarketId";
import { prepareSectionSlugList } from "../prepareSectionsList";

const stockSlugListCache = new Map();
const stockSlugListInflight = new Map();

const getCacheKey = (locale, preparedMarketId) =>
  `${locale}:${String(preparedMarketId || "").toLowerCase()}`;

export default class SEOHelper {
  static async getStockSlugList(
    locale,
    authToken,
    marketId,
    marketTranslations
  ) {
    if (!marketId) {
      return undefined;
    }

    const preparedMarketId = getDefaultMarketId(marketTranslations, marketId);
    const cacheKey = getCacheKey(locale, preparedMarketId);

    if (stockSlugListCache.has(cacheKey)) {
      return stockSlugListCache.get(cacheKey);
    }

    if (stockSlugListInflight.has(cacheKey)) {
      return stockSlugListInflight.get(cacheKey);
    }

    const apiClient = new ApiClientAsync(locale, authToken);
    const request = apiClient
      .get({
        urlPath: "app.stockSeoData.getSectionList",
        variables: {
          marketId: preparedMarketId
        }
      })
      .then(slugList => {
        stockSlugListCache.set(cacheKey, slugList);
        return slugList;
      })
      .finally(() => {
        stockSlugListInflight.delete(cacheKey);
      });

    stockSlugListInflight.set(cacheKey, request);
    return request;
  }

  static async getPreparedSectionSlugList({
    locale,
    authToken,
    marketId,
    marketTranslations
  }) {
    if (!marketId) {
      return {};
    }

    const slugList = await SEOHelper.getStockSlugList(
      locale,
      authToken,
      marketId,
      marketTranslations
    );

    return prepareSectionSlugList(slugList);
  }

  /**
   * Clears the module-level stock section slug list cache.
   * Intended for unit tests only so cases do not leak cache across runs.
   */
  static clearPreparedSectionSlugListCache() {
    stockSlugListCache.clear();
    stockSlugListInflight.clear();
  }

  static async getStockSeoMetadata(
    locale,
    authToken,
    marketId,
    stockId,
    section = "main",
    marketTranslations
  ) {
    const preparedMarketId = getDefaultMarketId(marketTranslations, marketId);

    if (marketId) {
      const apiClient = new ApiClientAsync(locale, authToken);
      return await apiClient.get({
        urlPath: "app.stockSeoData.getSectionSeoData",
        variables: {
          marketId: preparedMarketId,
          stockId,
          section: section ? section : "main"
        }
      });
    }

    return null;
  }
}
